import { ChakraProvider } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

interface ChakraProps extends PropsWithChildren {
  customTheme: Record<string, any>
}

const CustomChakraProvider = ({ customTheme, children }: ChakraProps) => {
  return (
    <ChakraProvider
      toastOptions={{
        defaultOptions: {
          position: 'top-right',
          duration: 5000,
          isClosable: true,
        },
      }}
      theme={customTheme}
    >
      {children}
    </ChakraProvider>
  );
};

export default CustomChakraProvider;
